import React from 'react'
import { toast } from 'react-toastify'
import { LinkedInIconSecondary, XIcon } from '../Icons'

interface ShareButtonsProps {
  slug: string
  className?: string
}

const generateShareUrls = (slug: string) => {
  const twinUrl = `${window.location.origin}/${slug}`
  const shareText = 'My AI twin is live! Ask it anything.'
  const hashtags = 'Napster,DigitalTwin'

  return {
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(twinUrl)}`,
    twitter: `https://twitter.com/intent/tweet?url=${encodeURIComponent(twinUrl)}&text=${encodeURIComponent(shareText)}&hashtags=${encodeURIComponent(hashtags)}`,
    twinUrl,
  }
}

export const ShareButtons: React.FC<ShareButtonsProps> = ({
  slug,
  className = '',
}) => {
  const shareUrls = generateShareUrls(slug)

  const handleCopyLink = () => {
    navigator.clipboard
      .writeText(shareUrls.twinUrl)
      .then(() => {
        toast.success('Link copied to clipboard!')
      })
      .catch(error => {
        console.error('Failed to copy link to clipboard:', error)
        toast.error('Failed to copy link')
      })
  }

  return (
    <div className={`flex items-center gap-4 ${className}`}>
      <button className="btn btn-primary !border-0" onClick={handleCopyLink}>
        <i className="fa-solid fa-copy text-lg me-2" />
        Copy link
      </button>
      <a
        href={shareUrls.linkedin}
        target="_blank"
        rel="noopener noreferrer"
        className="btn bg-[#0A66C2] !border-0 hover:bg-[#004281] "
      >
        <LinkedInIconSecondary />
        <span className="hidden sm:inline ms-2">Share on LinkedIn</span>
      </a>
      <a
        href={shareUrls.twitter}
        target="_blank"
        rel="noopener noreferrer"
        className="btn !bg-black !border !border-black"
      >
        <XIcon />
        <span className="hidden sm:inline ms-2">Share on X</span>
      </a>
    </div>
  )
}
